import { CaretDownFilled } from "@ant-design/icons";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form, Modal, Select } from "antd";
import TextArea from "antd/es/input/TextArea";
import { useState } from "react";
import Spinner from "@src/components/spinner";


export const TimeSheetActionComment = ({visible, close, comments, setComments, status, handelSubmit, loading})=>{


    return(

        <Modal    
            visible={visible}
            width={600}
            footer={
                <div 
                    className="drawer-footer"
                >

                    <button disabled={loading} className={loading?'disabled-btn drawer-filled-btn':'drawer-filled-btn'} onClick={handelSubmit}>
                       {loading? <Spinner/> : "Confirm"}
                    </button>

                    <button disabled={loading}  className={'drawer-outlined-btn'} onClick={close}>
                        Cancel
                    </button>

                </div>
            }
            closable={false}
        >

            <div className={+ status? 'modal-header-title ' : 'modal-header-title  archive-modal-header'}>
                <span style={{letterSpacing:'0.2px'}}> {status? "Approve TimeSheet" : "Reject TimeSheet"} </span>
                <span  onClick={close}><FontAwesomeIcon className='close' icon={faClose}/></span>
            </div>

            <div className="modal-body" style={loading?{opacity:"0.2"} : {opacity:1}}>

                <Form.Item>
                    <label>Comments (if any?)</label>
                    <TextArea 
                        placeholder="Comments if any?"
                        onChange={(e)=>setComments(e.target.value)}
                        value={comments}
                        className="generic-input-control"
                    />
                </Form.Item>

                
            </div>

        </Modal>
    )
}